import React from 'react';
import { DL, DT } from '@components/List';
import { Box, Flex } from '@components/layout/Grid';

const arrayToSentence = arr => {
  if (arr.length === 1) {
    return arr[0];
  } else {
    var last = arr.pop();
    return arr.join(', ') + ' and ' + last;
  }
};

const TermsList = props => {
  return (
    <Flex
      as={DL}
      mt="0px"
      mb="5px"
      data-testid={props['data-testid'] || 'TermsList'}
    >
      <Box as={DT} flex="0 0 100px">
        {props.label}:
      </Box>
      <Box ml={0} as="dd" width={'1 auto'}>
        {Array.isArray(props.data)
          ? arrayToSentence(props.data.map(item => item.name))
          : props.data}
      </Box>
    </Flex>
  );
};

export default TermsList;
